import API from "../../../store/api";
import { setNotifications } from '../../../store/actions/notificationActions';
import { clearMessage, setMessage } from '../../../store/actions/dialogActions';
import { clearEsriFields, setEsriFields } from '../../../store/actions/esriActions';
import { authLogout } from '../../../store/actions/authActions';

export const esriFieldsFromObject = (data, bearerAuth) => {
  return async dispatch => {
    API.post(`/api/portal/esri/fields/object`)
      .set('Authorization', `Bearer ${bearerAuth}`)
      .send(data)
      .ok(res => res.status === 200 || res.status === 401)
      .then((response) => {
        if (response.status === 200) {
          let data = JSON.parse(response.text);
          if (data.fields) { //ESRI service
            dispatch(setEsriFields(data.fields))
          } else if (data?.metadata?.properties){ //GeoJSON
            dispatch(setEsriFields(data.metadata.properties))
          }
        } else if (response.status === 401) {
          dispatch(clearEsriFields);
          dispatch(authLogout);
        }
      }).catch((error) => {
        console.log(error)
        let message = 'An error has occurred';
        if (error.message) {
          message = error.message;
        }
        if (error.response && error.response.body) {
          if (error.response.body.messages) {
            message = error.response.body.messages.toString();
            if (message.includes(',')) { //Password error, make it more presentable
              let messageArray = message.split(',');
              message = <>{messageArray.map((val) => <div>{val}</div>)}</>
            }
          } 
        }
        dispatch(setMessage({
          title: 'Failed to pull field options',
          message: 'Invalid Token URL/Credentials Provided',
          type: 'ERR',
        }))
      })
  }
}